import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Close from "../../../../assets/images/close-icon.png";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import PDF from "../../../../assets/images/pdf.svg";
import { getCampaignView } from "../../../../redux/actions/campaignActions";
import { getCampaignRatingsAdmin } from "../../../../redux/actions/dealFlowActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import ProfilePic from "../../../../assets/images/dummy_profile.png";
import { AdminStarRating, InterestStatsPanel } from "../../../../components/DealFlow";
import { canApprove } from "../../../../utils/dealFlowRoleUtils";
import { getErrorMessage } from "../../../../utils/errorUtils";
import "../../../../components/common/css/campaignview.scss";
import "../../../../components/common/css/modal.scss";
import { useReactToPrint } from "react-to-print";
import Box from "@mui/material/Box";

const CampaignView = () => {
  const [loading, setLoading] = useState(false);
  const [business_plan_docs, setBuiness_Plan_Docs] = useState([]);
  const [other_docs, setOther_Docs] = useState([]);
  const [comment, setComment] = useState("");
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const campaignView = useSelector((state) => state.campaignView);
  const { campaign } = campaignView;
  const dealFlow = useSelector((state) => state.dealFlow);
  const navigate = useNavigate();
  const { campaignId: campaignIdParam } = useParams();
  const resolvedCampaignId = campaignIdParam ? Number(campaignIdParam) : campaign?.data?.[0]?.id || null;
  const ratingsData = resolvedCampaignId ? dealFlow?.ratings?.[resolvedCampaignId] || null : null;
  const adminId = JSON.parse(localStorage.getItem("admin"))?.data?.id || null;
  const myRating = ratingsData?.individual_ratings?.find((rating) => rating?.user_id === adminId) || null;
  const token = localStorage.getItem("accessToken");
  let campaign_id = campaign?.data[0]?.id?.toString()?.padStart(8, "0");
  const componentRef = useRef();
  const [history, setHistory] = useState([]);
  const handleClose = () => setOpen(false);
  const [productsType, setProductsType] = useState([]);
  const [productId, setProductId] = useState();
  const [campaignType, setCampaignType] = useState("");

  // const onOpenModal = () => setOpen(true);
  // const onCloseModal = () => setOpen(false);
  useEffect(() => {
    // console.log("camp", campaignView.campaign.data[0]);
    if (campaignView) {
      if (campaignView?.loading !== undefined) {
        setLoading(campaignView?.loading);
      }
      setBuiness_Plan_Docs(
        campaignView?.campaign?.data[0]?.business_plan_docs?.filter(
          (x) => x.is_other === 0
        )
      );
      setOther_Docs(
        campaignView?.campaign?.data[0]?.business_plan_docs?.filter(
          (x) => x.is_other === 1
        )
      );
    }
  }, [campaignView]);

  useEffect(() => {
    if (campaignIdParam) {
      dispatch(getCampaignView(token, { campaignId: campaignIdParam }));
    }
  }, [dispatch, token, campaignIdParam]);

  useEffect(() => {
    if (resolvedCampaignId) {
      dispatch(getCampaignRatingsAdmin(resolvedCampaignId));
    }
  }, [dispatch, resolvedCampaignId]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: campaign_id + "-User-QnA",
    // onAfterPrint: () => alert("Data saved in PDF"),
  });

  const approveCampaign = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "update-campaign-byadmin",
      headers: {
        "x-access-token": token,
      },
      data: {
        campaign_id: campaignIdParam,
        campaign_status: 3,
        reason: comment,
        product_type: productId,
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status === 200) {
          setLoading(false);
          Swal.fire({
            title: "Approve Successfully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        navigate("/active-campaign");
      })
      .catch(function (error) {
        setLoading(false);
        const errorMessage = getErrorMessage(
          error,
          "Failed to approve campaign"
        );
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: errorMessage,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      });
  };
  const getProducts = useCallback(() => {
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-campaign-products",
      headers: {
        "x-access-token": token,
      },
      data: {
        type: campaign?.data?.[0]?.type,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data;
        setProductsType(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [token, campaign?.data?.[0]?.type]);

  const handleCampaignTypeSubmit = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/update-campaign-type",
      headers: {
        "x-access-token": token,
      },
      data: {
        campaign_id: campaignIdParam,
        campaign_type: campaignType,
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status === 200) {
          setLoading(false);
          Swal.fire({
            title: "Updated Successfully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
      })
      .catch(function (error) {
        setLoading(false);
        const errorMessage = getErrorMessage(
          error,
          "Failed to update campaign type"
        );
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: errorMessage,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      });
  };
  const declineCampaign = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "update-campaign-byadmin",
      headers: {
        "x-access-token": token,
      },
      data: {
        campaign_id: campaignIdParam,
        campaign_status: 2,
        reason: comment,
      },
    };

    axios(config)
      .then(function (response) {
        if (response.data.status === 200) {
          setLoading(false);
          Swal.fire({
            title: "Rejected Succesffully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        navigate("/rejected-campaign");
      })
      .catch(function (error) {
        setLoading(false);
        const errorMessage = getErrorMessage(
          error,
          "Failed to reject campaign"
        );
        Swal.fire({
          title: errorMessage,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };
  const dateFormat = (date) => {
    const notificationDate = new Date(date);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let temp =
      months[notificationDate.getMonth()] +
      " " +
      notificationDate.getDate() +
      ", " +
      notificationDate.getFullYear() +
      "   at  " +
      notificationDate.getHours() +
      ":" +
      notificationDate.getMinutes();
    return temp;
  };

  const viewHstory = useCallback(() => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/getAllLogsofCamapignbyId",
      headers: {
        "x-access-token": token,
      },
      data: {
        slug: campaign?.data[0]?.slug,
        user_id: campaign?.data[0]?.user_id,
        campaign_id: campaignIdParam,
      },
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        // console.log(response?.data?.data?.rows);

        setHistory(response?.data?.data?.rows);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  }, [campaign?.data, campaignIdParam]);
  // console.log(history,"xyz");
  useEffect(() => {
    if (
      campaignView?.campaign?.status === 200 &&
      campaignView?.campaign?.success === true
    ) {
      viewHstory();
      getProducts();
    }
  }, [campaignView, getProducts, viewHstory]);

  const d = new Date(campaign?.data[0]?.user?.dob);
  // const other_docs = campaign?.data[0]?.business_plan_docs;
  // console.log("other_docs",other_docs.filter((x) => x.is_other == 0),)
  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <Loader isLoading={loading} />

        <div className="top">
          {campaign?.data?.map((userInfo) => (
            <div key={userInfo?.id}>
              <div className="left">
                <div className="title-topSection">
                  <h1 className="title">Personal Information</h1>
                  <button onClick={handleOpen} className="editButton">
                    History
                  </button>
                </div>
                <div className="item">
                  <img
                    src={
                      userInfo.user.profilePic
                        ? userInfo.user.profilePic
                        : ProfilePic
                    }
                    alt="Profile"
                    className="itemImg"
                  />
                  <div className="details profile-info">
                    {/* <h1 className="itemTitle">
                      {userInfo.user.firstname} {userInfo?.user?.lastname}
                    </h1> */}
                    <div className="detailItem">
                      <span className="itemKey">Name:</span>
                      <span className="itemValue">
                        <b>
                          {userInfo?.user?.salutations}{" "}
                          {userInfo.user.firstname} {userInfo?.user?.lastname}
                        </b>
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Email:</span>
                      <span className="itemValue">{userInfo?.user?.email}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Phone:</span>
                      <span className="itemValue">
                        {userInfo?.user?.phone === "null"
                          ? ""
                          : userInfo?.user?.phone}
                      </span>
                    </div>
                    {/* <div className="detailItem">
                      <span className="itemKey">Status:</span>

                      <span className="itemValue">
                        {userInfo?.user?.userStatus == 1
                          ? "Active"
                          : "Inactive"}
                      </span>
                    </div> */}
                    <div className="detailItem">
                      <span className="itemKey">Current Address:</span>
                      <span className="itemValue">
                        {userInfo?.user?.current_address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Floor:</span>
                      <span className="itemValue">
                        {userInfo?.user?.address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">City:</span>
                      <span className="itemValue">{userInfo?.user?.city}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Postal Code:</span>
                      <span className="itemValue">
                        {userInfo?.user?.postal_code}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Country:</span>
                      <span className="itemValue">
                        {userInfo?.user?.user_country?.country_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">State/Province:</span>
                      <span className="itemValue">
                        {userInfo?.user?.user_state?.state_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">DOB:</span>
                      <span className="itemValue">
                        {d?.toLocaleDateString()}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Gender:</span>
                      <span className="itemValue">
                        {userInfo?.user?.gender}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Marital Status:</span>
                      <span className="itemValue">
                        {userInfo?.user?.marital_status}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Employer:</span>
                      <span className="itemValue">
                        {userInfo?.user?.employer}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Occupation:</span>
                      <span className="itemValue">
                        {userInfo?.user?.occupation}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Sin:</span>
                      <span className="itemValue">{userInfo?.user?.sin}</span>
                    </div>
                    {/* <div className="detailItem">
                      <span className="itemKey">Cell:</span>
                      <span className="itemValue">
                        {userInfo?.user?.mobile}
                      </span>
                    </div> */}
                  </div>
                </div>
                {/* <span className="file-note-msg">
                  <b>Note</b>: This campaign is deleted.{" "}
                </span> */}
              </div>

              <div className="left">
                {/* <div className="editButton">Edit</div> */}
                <div className="Corporate-pdf">
                  <button
                    type="button"
                    className="approveButton downloadbtn"
                    onClick={handlePrint}
                  >
                    Download
                  </button>
                </div>
                <div className="corporateInfo-btn" ref={componentRef}>
                  <h1 className="title">Corporate Information</h1>

                  <div className="item corporateInfo-section">
                    <img
                      src={
                        userInfo?.campaing_logo
                          ? userInfo?.campaing_logo
                          : ProfilePic
                      }
                      alt="Campaign"
                      className="itemCorpImg"
                    />
                    <div className="details profile-info">
                      <div className="detailItem">
                        <span className="itemKey">
                          Inventme Article Name(Link):
                        </span>
                        <span className="itemValue">
                          {userInfo?.article_name ? userInfo.article_name : "-"}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">
                          Inventme Article Id(Link):
                        </span>
                        <span className="itemValue">
                          {userInfo?.article_id ? userInfo.article_id : "-"}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Campaign ID:</span>
                        <span className="itemValue">{campaign_id}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Company Name:</span>
                        <span className="itemValue">
                          {userInfo.corporation_legal_name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Company City:</span>
                        <span className="itemValue">{userInfo?.city}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Head Office Address</span>
                        <span className="itemValue">
                          {userInfo?.registered_address}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Phone:</span>
                        <span className="itemValue">{userInfo?.phone}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Email:</span>
                        <span className="itemValue">
                          {userInfo?.camp_email}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Country</span>
                        <span className="itemValue">
                          {userInfo?.user_country?.country_name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">State/Province</span>
                        <span className="itemValue">
                          {userInfo?.user_state?.state_name}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Postal Code</span>
                        <span className="itemValue">
                          {userInfo?.postal_code}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Type Of Enitity:</span>
                        <span className="itemValue">{userInfo.entitytype}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Website</span>
                        <span className="itemValue">{userInfo?.website}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Buisness No:</span>
                        <span className="itemValue">{userInfo.business}</span>
                      </div>

                      <div className="detailItem">
                        <span className="itemKey">Fax</span>
                        <span className="itemValue">{userInfo.fax}</span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Crax Acoount</span>
                        <span className="itemValue">
                          {userInfo.craax_account}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Years Of Corp</span>
                        <span className="itemValue">
                          {userInfo?.date_of_incorp}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Incorp Register</span>
                        <span className="itemValue">
                          {userInfo?.in_corporation_registration}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Currency</span>
                        <span className="itemValue">
                          {/* {userInfo?.user?.defaultcurrency} */}
                          CAD
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Goal Amount</span>
                        <span className="itemValue">
                          {/* {userInfo?.user?.defaultcurrency == "INR"
                            ? "₹"
                            : userInfo?.user?.defaultcurrency == "EUR"
                            ? "€"
                            : "$"} */}{" "}
                          ${userInfo?.goal_invest_amnt}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Minimum Investment</span>
                        <span className="itemValue">
                          {/* {userInfo?.user?.defaultcurrency == "INR"
                            ? "₹"
                            : userInfo?.user?.defaultcurrency == "EUR"
                            ? "€"
                            : "$"} */}
                          ${userInfo?.minimum_investment}
                        </span>
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Other Investment</span>
                        <span className="itemValue">
                          {/* {userInfo?.user?.defaultcurrency == "INR"
                            ? "₹"
                            : userInfo?.user?.defaultcurrency == "EUR"
                            ? "€"
                            : "$"} */}
                          ${userInfo?.outside_roots_investment}
                        </span>
                      </div>
                      {userInfo?.type === "EQUITY" ? (
                        <div className="detailItem">
                          <span className="itemKey">Company Valuation</span>
                          <span className="itemValue">
                            {/* {userInfo?.user?.defaultcurrency == "INR"
                            ? "₹"
                            : userInfo?.user?.defaultcurrency == "EUR"
                            ? "€"
                            : "$"} */}
                            ${userInfo?.company_valuation}
                          </span>
                        </div>
                      ) : (
                        <div className="detailItem">
                          <span className="itemKey">In Which Form</span>
                          <span className="itemValue">
                            {userInfo?.loan_type}
                          </span>
                        </div>
                      )}

                      {userInfo?.type === "EQUITY" ? (
                        <div className="detailItem">
                          <span className="itemKey">No Closing Minimum</span>
                          <span className="itemValue">
                            {/* {userInfo?.user?.defaultcurrency == "INR"
                            ? "₹"
                            : userInfo?.user?.defaultcurrency == "EUR"
                            ? "€"
                            : "$"} */}
                            ${userInfo?.no_closing_minimum}
                          </span>
                        </div>
                      ) : (
                        <div className="detailItem">
                          <span className="itemKey">
                            Brief description on how you will use this funds
                          </span>
                          <span className="itemValue">
                            {userInfo?.fund_use}
                          </span>
                        </div>
                      )}

                      {userInfo?.type === "EQUITY" ? (
                        <div className="detailItem">
                          <span className="itemKey">Price per security</span>
                          <span className="itemValue">
                            {userInfo?.price_per_security}
                          </span>
                        </div>
                      ) : (
                        <div className="detailItem">
                          <span className="itemKey">
                            Which Is The Purpose Of This Financing?
                          </span>
                          <span className="itemValue">
                            {userInfo?.purpose_of_financing}
                          </span>
                        </div>
                      )}

                      {userInfo?.type === "EQUITY" ? (
                        <div className="detailItem">
                          <span className="itemKey">Security Type</span>
                          <span className="itemValue">
                            {userInfo?.security_type}
                          </span>
                        </div>
                      ) : (
                        <div className="detailItem">
                          <span className="itemKey">
                            Which return you would like to offer to the
                            investors?
                          </span>
                          <span className="itemValue">
                            {userInfo?.interest_rate}
                          </span>
                        </div>
                      )}

                      {userInfo?.type === "EQUITY" ? (
                        <div className="detailItem">
                          <span className="itemKey">
                            Number of shares issued in this campaign
                          </span>
                          <span className="itemValue">
                            {userInfo?.issued_shares}
                          </span>
                        </div>
                      ) : (
                        <div className="detailItem">
                          <span className="itemKey">
                            What's your desired loan's duration in months?
                          </span>
                          <span className="itemValue">
                            {userInfo?.loan_duration_in_month}
                          </span>
                        </div>
                      )}

                      {userInfo?.type === "EQUITY" ? (
                        <div className="detailItem">
                          <span className="itemKey">
                            Total Company’s shares issued
                          </span>
                          <span className="itemValue">
                            {userInfo?.issued_shares_company}
                          </span>
                        </div>
                      ) : (
                        <div className="detailItem">
                          <span className="itemKey">
                            Can you offer any guarantees to the investor?
                          </span>
                          <span className="itemValue">
                            {userInfo?.guarantee_type}
                          </span>
                        </div>
                      )}

                      <div className="detailItem">
                        <span className="itemKey">How Many Years Buisness</span>
                        <span className="itemValue">
                          {userInfo.how_many_yearsin_business}
                        </span>
                      </div>

                      <div className="detailItem">
                        <span className="itemKey">Nature Of Buisness</span>
                        {Array.isArray(userInfo?.nature_of_businesses) ? (
                          userInfo?.nature_of_businesses.map((cat, index) => {
                            return (
                              <li className="itemValue">
                                {cat?.business_category?.category_name}
                              </li>
                            );
                          })
                        ) : (
                          <h4>No Data Found</h4>
                        )}
                      </div>
                      <div className="detailItem">
                        <span className="itemKey">Feature</span>
                        {Array.isArray(userInfo?.features) ? (
                          userInfo?.features.map((feature, index) => {
                            return (
                              <li className="itemValue">
                                {feature?.feature_title}
                              </li>
                            );
                          })
                        ) : (
                          <h4>No Data Found</h4>
                        )}
                      </div>
                      <div className="buisnessPlan">
                        <span className="itemKey">Buisness Plan Docs</span>
                        <div className="itemValue">
                          {business_plan_docs?.length > 0 ? (
                            business_plan_docs?.map((pdf, i) => (
                              <>
                                <a
                                  href={pdf.document_name}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="docLink"
                                >
                                  {pdf?.document_name !== null && (
                                    <img src={PDF} className="docImage" alt="Document" />
                                  )}

                                  {pdf?.document_name !== null && (
                                    <p className="docName">doc {i + 1}</p>
                                  )}
                                </a>
                              </>
                            ))
                          ) : (
                            <h6>No Data Found</h6>
                          )}
                        </div>
                      </div>

                      <div className="buisnessPlan">
                        <span className="itemKey">Other Docs</span>
                        <div className="itemValue">
                          {other_docs?.length > 0 ? (
                            other_docs?.map((pdf, i) => (
                              <>
                                <a
                                  href={pdf.document_name}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="docLink"
                                >
                                  {pdf?.document_name !== null && (
                                    <img src={PDF} className="docImage" alt="Document" />
                                  )}

                                  {pdf?.document_name !== null && (
                                    <p className="docName">doc {i + 1}</p>
                                  )}
                                </a>
                              </>
                            ))
                          ) : (
                            <h6>No Data Found</h6>
                          )}
                        </div>
                      </div>

                      <div className="buisnessPlan">
                        <span className="itemKey">Campaign Banner</span>
                        <div className="itemValue">
                          {userInfo?.banner_img ? (
                            <img
                              src={userInfo?.banner_img}
                              alt="Campaign banner"
                              className="campaignBanner-img"
                            />
                          ) : (
                            "No Data Found"
                          )}
                        </div>
                      </div>

                      {/* for lending products */}
                      {/* {userInfo?.type == "LENDME" ?  */}
                      <div className="detailItem product-drp">
                        <span className="itemKey">Select Product</span>
                        <select
                          className="txtInput productSelection-drp drpSelect"
                          name="product"
                          onChange={(e) => setProductId(e.target.value)}
                          value={productId}
                        >
                          <option value="" disabled selected>
                            Select Value
                          </option>
                          {productsType.map((getProducts, index) => (
                            <option
                              key={index}
                              value={getProducts.product_name}
                            >
                              {getProducts?.product_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {/* Deal Flow: 5-Star Admin Rating System */}
                      <div className="dealflow-section" style={{ marginTop: "24px" }}>
                        <AdminStarRating
                          campaignId={userInfo?.id}
                          initialRating={myRating?.rating || 0}
                          initialNotes={myRating?.notes || ""}
                          onRatingSubmit={() => {
                            dispatch(getCampaignRatingsAdmin(resolvedCampaignId));
                          }}
                        />

                        {/* Deal Flow: Investor Interest Statistics */}
                        <InterestStatsPanel
                          campaignId={userInfo?.id}
                          currency={userInfo?.currency_type || "USD"}
                        />
                      </div>

                      {/* <div className=" idDocs">
                      <span className="itemKey">Id Proof Docs</span>
                      <div className="itemValue">
                        {userInfo?.id_proof_docs?.length > 0 ? (
                          userInfo?.id_proof_docs?.map((id, i) => (
                            <>
                              <a
                                href={id.document_name}
                                target="_blank"
                                className="docLink"
                              >
                                {id.document_name !== null && (
                                  <img
                                    src={id?.document_name}
                                    className="docImage"
                                  />
                                )}
                                {id?.document_name !== null && (
                                  <p className="docName">doc {i + 1}</p>
                                )}
                              </a>
                              {/* <p>{document}</p> */}
                      {/* </>
                            //
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                    </div> */}
                    </div>
                  </div>
                  <hr></hr>
                  <div
                    className="left mt-5"
                    style={{ boxShadow: "none", padding: "0" }}
                  >
                    {/* <div className="editButton">Edit</div> */}
                    <h1 className="title">
                      Campaign related Questions/Answers
                    </h1>
                    <div className="item">
                      <div className="details profile-info">
                        {userInfo?.campaign_que_ans?.length > 0 ? (
                          userInfo?.campaign_que_ans?.map((que) => (
                            <div
                              className="detailItem companyInfo"
                              key={uuidv4()}
                            >
                              <span className="itemKey">{que.question}:</span>
                              <span className="itemValue">{que.answer}</span>
                            </div>
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="left">
                <h1 className="title">Bank Information</h1>

                <div className="item">
                  <div className="details profile-info">
                    <div className="detailItem">
                      <span className="itemKey">Bank Name:</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.bank_name}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Account Number</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.account_number
                        }
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Bank Institution:</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.institution}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Bank Transit Number</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.transit_number
                        }
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Bank Swift Code</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.swift_code}
                      </span>
                    </div>

                    <div className=" idDocs">
                      <span className="itemKey">Bank Docs</span>
                      <div className="itemValue">
                        <a
                          href={
                            userInfo?.profile_individual_bankdetails?.bankdoc
                          }
                          target="_blank"
                          rel="noreferrer"
                          className="docLink"
                        >
                          {userInfo?.profile_individual_bankdetails?.bankdoc !==
                            null && <img src={PDF} className="docImage" alt="Bank document" />}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="left">
                
                <h1 className="title">Bank Information</h1>
                <div className="item">
                  <div className="details profile-info">
                    <div className="detailItem">
                      <span className="itemKey">Bank Name:</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.bank_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Public Code:</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.bankPublicCode
                        }
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Address</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.bank_address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Street</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.street_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">City</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.city}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Phone:</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.bank_phone_number
                        }
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Country</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails?.user_country
                            ?.country_name
                        }
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">State/Province</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails?.user_state
                            ?.state_name
                        }
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Postal Code</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.postal_code}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Account Number:</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.account_number
                        }
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Institution</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.institution}
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="left">
                <h1 className="title">Update Campaign Type</h1>

                <div className="detailItem product-drp">
                  <span className="itemKey">Select Type</span>
                  <select
                    className="txtInput productSelection-drp drpSelect"
                    value={campaignType || userInfo?.campaign_for || ""}
                    onChange={(e) => {
                      setCampaignType(e.target.value);
                    }}
                  >
                    <option value="" disabled>
                      Select type
                    </option>
                    <option value="Offering Memorandum">
                      Offering Memorandum
                    </option>
                    <option value="Start Up">Start Up</option>
                    <option value="Accredited Investor">
                      Accredited Investor
                    </option>
                  </select>
                </div>
                <Button
                  variant="contained"
                  className="approveButton"
                  onClick={handleCampaignTypeSubmit}
                >
                  Submit
                </Button>
              </div>
              {/* Approval Section - Hidden for Evaluators (can only rate, not approve) */}
              {canApprove() ? (
                <div className="left">
                  <h1 className="title">
                    You can click on Approve / Reject button below to respond.
                  </h1>
                  <textarea
                    type="text"
                    name="about_profile"
                    cols="47"
                    rows="8"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    className="description-textarea"
                    placeholder="Enter reason"
                  ></textarea>
                  <div className="item">
                    <div className="details profile-info">
                      <div className="submitButton">
                        <Button
                          variant="contained"
                          className="approveButton"
                          onClick={approveCampaign}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="contained"
                          className="declineButton"
                          onClick={declineCampaign}
                        >
                          Reject
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="left">
                  <div className="evaluator-notice" style={{ padding: "16px", background: "#fff3e0", borderRadius: "8px", textAlign: "center" }}>
                    <h4 style={{ color: "#e65100", marginBottom: "8px" }}>Evaluator Access</h4>
                    <p style={{ color: "#666", margin: 0 }}>
                      As an Evaluator, you can rate campaigns but cannot approve or reject them.
                      Your ratings will be recorded for internal review.
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}

          {/* <Modal
           open={open}
           onClose={onCloseModal}
           closeOnOverlayClick={false}
           styles={{ modal: { maxWidth: "1000px" } }}
           >
            <h3 className="modal-tittle">History</h3>
            {
              history?.map((campaign, index) => {
                return(
                  <div>
                    
                    <div>
                    <p>Status:</p>
                    <p>{campaign?.action}</p>
                    </div>
                  </div>
                )
              })
            }
           */}

          {/* </Modal> */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="modal-popup">
              <div className="modal-top">
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Campaign Activity
                </Typography>
                <Button className="closeBtn" onClick={() => setOpen(false)}>
                  <img src={Close} alt="close-icon" />
                </Button>
              </div>
              <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                <div className="new">
                  <div className="newContainer">
                    <div
                      className="bottom"
                      style={{ boxShadow: "none", padding: "0" }}
                    >
                      <div className="right">
                        <form className="accredited-investorForm">
                          {history.length > 0 ? (
                            <div className="history-infoWrap">
                              {/* <p className="createdAt-value">
                            {dateFormat(history?.[0]?.timestamp)}
                          </p> */}

                              {/* <p className="campName-value">
                            {
                              history?.[0]?.campaign_detail
                                ?.corporation_legal_name
                            }
                          </p> */}
                              {/* <p className="status-value">
                            {history?.[0]?.action}
                          </p> */}
                              <p className="campCreated-name">
                                {history?.[0]?.user?.firstname}
                                &nbsp;
                                {history?.[0]?.user?.lastname}&nbsp; Updated The
                                Status to &nbsp;
                                {history?.[0]?.action}&nbsp; on &nbsp;
                                {dateFormat(history?.[0]?.timestamp)}&nbsp; For
                                &nbsp;
                                {
                                  history?.[0]?.campaign_detail
                                    ?.corporation_legal_name
                                }
                                &nbsp; Campaign.s
                              </p>
                            </div>
                          ) : (
                            <h3>No Data Found</h3>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </Typography>
            </Box>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default CampaignView;
